<template>
  <div v-if="!isAuthenticationProcessed" class="text-center p-5 " style="width: 100%; position: absolute;">
    <img src="../../../assets/images/webex-logo.png"/>
    <h2 class="mb-3 mt-3">Connect Webex Account</h2>

    <center>
      <h6 style="text-align: left; max-width: 500px;" class="mb-3">To connect Webex account, log into your Webex
        Developer Account and create a new service app. Once created, locate the "Client ID", "Client Secret", "Access
        Token" and "Refresh Token" within the app settings.
      </h6>
      <div style="max-width: 350px;">
        <div class="mt-3">
          <p class="text-start small-text mb-2 p-1 alert alert-info">
            Default Webex API URL is <strong>https://webexapis.com/v1</strong>. This default URL should work fine for
            most users. However, if you have any special URL provided to you by WebEx, you can change the following
            value to your own URL.
          </p>
          <input
              v-model="webexServiceObj.url"
              autocomplete="off"
              type="text"
              placeholder="Enter Webex API URL"
              class="search-input"
          />
        </div>

        <input
            v-model="webexServiceObj.email"
            autocomplete="off"
            type="email"
            placeholder="Enter your Webex Account Email"
            class="search-input mt-3"
        />
        <input
            v-model="webexServiceObj.clientId"
            autocomplete="off"
            type="search"
            placeholder="Enter Webex Client ID"
            class="search-input mt-3"
        />
        <input
            v-model="webexServiceObj.clientSecret"
            autocomplete="off"
            type="search"
            placeholder="Enter Webex Client Secret"
            class="search-input mt-3"
        />
        <input
            v-model="webexServiceObj.accessToken"
            autocomplete="off"
            type="search"
            placeholder="Enter Webex Access Token"
            class="search-input mt-3"
        />
        <input
            v-model="webexServiceObj.refreshToken"
            autocomplete="off"
            type="search"
            placeholder="Enter Webex Refresh Token"
            class="search-input mt-3"
        />
        <div class="mt-3">
          <input
              v-model="webexServiceObj.secretToken"
              readonly
              class="search-input"
          />
          <p class="text-start small-text mt-2 mb-2 p-1 alert alert-info">
            This is your <strong>Secret Token</strong>. Please copy and save it securely. This will be required to add
            in your WebEx portal.
          </p>
          <button @click="copySecretToken" class="connect-btn step-btn mb-3">Copy Secret Token</button>
        </div>

        <p v-if="error" class="text-danger mb-2">{{ error }}</p>
        <button @click="createWebExApp" class="connect-btn step-btn mb-3">Connect</button>
        <!-- <h6>Or</h6>
        <button @click="makeOAuthServiceConnection" class="step-btn mb-3">
          <i  style="color: #2D8CFF; font-weight: bold;" class="fa fa-video"></i>
           Continue With <span style="color: #2D8CFF; font-weight: bold;"> Zoom </span></button> -->
      </div>
    </center>
  </div>
  <div v-else-if="isAuthenticationProcessed" class="ms-5 pt-5">
    <img src="../../../assets/images/webex-logo.png"/>
    <h2 class="pb-5 mt-1">Account Connecting<br/><small>Redirecting...</small></h2>
    <h5 v-if="message">{{ message }}</h5>
    <h5 v-if="error" class="text-danger">{{ error }}</h5>

  </div>

</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "WebexServiceApp",
  data() {
    return {
      message: undefined,
      error: undefined,
      isRedirected: false,
      isAuthenticationProcessed: false,
      webexServiceObj: {
        clientId: "",
        clientSecret: "",
        accessToken: "",
        refreshToken: "",
        secretToken: "",
        url: "https://webexapis.com/v1",
        email: ""
      }
    };
  },
  computed: {},
  methods: {
    ...mapActions("appState", ["createExternalServices"]),

    generateSecretToken() {
      // Example: 32-character base64 string
      const array = new Uint8Array(24);
      window.crypto.getRandomValues(array);
      return btoa(String.fromCharCode(...array));
    },

    copySecretToken() {
      navigator.clipboard.writeText(this.webexServiceObj.secretToken)
          .then(() => alert("Secret token copied to clipboard. Please save it securely."))
          .catch(() => alert("Failed to copy token. Please copy it manually."));
    },

    createWebExApp() {
      this.error = null;
      if (this.webexServiceObj &&
          this.webexServiceObj.clientId &&
          this.webexServiceObj.clientSecret &&
          this.webexServiceObj.accessToken &&
          this.webexServiceObj.refreshToken &&
          this.webexServiceObj.secretToken) {

        this.isAuthenticationProcessed = true;
        this.createExternalServices({
          type: "liveclass",
          provider: "webex",
          data: this.webexServiceObj
        }).then((response) => {
          if (response && response.error && response.error.message) {
            this.isAuthenticationProcessed = false;
            this.error = response.error.message;
            return;
          }

          if (response) {
            if (window.opener.beforeCloseCallback) {
              window.opener.beforeCloseCallback();
            }
            window.close();
          } else {
            this.isAuthenticationProcessed = false;
            this.error = "Some error occured. ERR_CODE: 002";
          }

        }).catch((err) => {
          this.isAuthenticationProcessed = false;
          this.error = "Some error cccured. ERR_CODE: 003";
        });

      } else {
        this.error = "Please fill all the fields";
      }
    }
  },
  created() {
    this.webexServiceObj.secretToken = this.generateSecretToken();
  }
}
</script>

<style scoped>
.search-input {
  background: #ffffff;
  border: 1px solid #dcdcdc;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  width: 100%;
  text-align: left;
  color: #000000;
  font-size: 1.5rem;
  column-gap: 0.75rem;
  position: relative;
  outline: none;
}

.connect-btn {
  background-color: #2D8CFF;
  border: #2D8CFF;
  color: #ffffff;
  font-size: small;

}

.step-btn {
  width: 100%;
}
</style>